// Every field on a product configuration is optional while the contract is
// unpublished, so each formatter has to answer "the service sent nothing" as
// well as "the service sent a value". N/A is the panel's existing convention
// for the former.
const NOT_AVAILABLE = 'N/A'

const isMissing = (value: unknown) => value === null || value === undefined || value === ''

export const formatText = (value: unknown): string =>
  isMissing(value) ? NOT_AVAILABLE : String(value)

const currencyFormatter = new Intl.NumberFormat('en-AU', {
  style: 'currency',
  currency: 'AUD',
  maximumFractionDigits: 2,
})

// 0 is a legitimate limit and a legitimate rate, so these test for a number
// rather than for truthiness.
const formatAmount = (value: unknown): string =>
  typeof value === 'number' && !Number.isNaN(value)
    ? currencyFormatter.format(value)
    : NOT_AVAILABLE

export const formatPercentage = (value: unknown): string =>
  typeof value === 'number' && !Number.isNaN(value) ? `${value}%` : NOT_AVAILABLE

// Ranges collapse to a single value when both ends match, and to whichever end
// is present when only one is.
const formatRange = (
  min: unknown,
  max: unknown,
  formatOne: (value: unknown) => string
): string => {
  const from = formatOne(min)
  const to = formatOne(max)

  if (from === NOT_AVAILABLE && to === NOT_AVAILABLE) return NOT_AVAILABLE
  if (from === to) return from
  return `${from} – ${to}`
}

export const formatAmountRange = (min: unknown, max: unknown) =>
  formatRange(min, max, formatAmount)

export const formatTextRange = (min: unknown, max: unknown) => formatRange(min, max, formatText)

export const formatPercentageRange = (min: unknown, max: unknown) =>
  formatRange(min, max, formatPercentage)
